import React from "react";
import { Switch, useRouteMatch } from "react-router-dom";
import PrivateRoute from "../../../../Routes/PrivateRoutes";
import TemplateSmsProvider from "./TemplateSmsContext";
import PesquisarTemplateSms from "./Events/PesquisarTemplateSms";
import FormularioTemplateSms from "./Events/FormularioTemplateSms";

const Index = () => {
  let match = useRouteMatch();
  return (
    <TemplateSmsProvider>
      <div className="container-fluid pl-3 pt-3 pb-3">
        <Switch>
          <PrivateRoute
            exact
            path={`${match.url}`}
            component={PesquisarTemplateSms}
          />
          <PrivateRoute
            path={`${match.url}/:id`}
            component={FormularioTemplateSms}
          />
        </Switch>
      </div>
    </TemplateSmsProvider>
  );
};

export default Index;
